"use strict";
function escapeRegexp(queryToEscape) {
    return queryToEscape.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
}
exports.escapeRegexp = escapeRegexp;



/*****************
 ** WEBPACK FOOTER
 ** ./~/ng2-select/components/select/common.js
 ** module id = 1050
 ** module chunks = 0
 **/